import caseattachmentsControl from 'bz-pronto-core/modules/clinical/case-attachments';
import casefooterControl from 'bz-pronto-core/modules/clinical/case-footer';
import casereportControl from 'bz-pronto-core/modules/clinical/case-report';
import moremenuitemControl from 'bz-pronto-core/modules/clinical/more-menu-item';
import reporteditorControl from 'bz-pronto-core/modules/clinical/report-editor';
import acknowledgedialogControl from 'bz-pronto-core/modules/finances/invoice/acknowledge-dialog';
import actionbarControl from 'bz-pronto-core/modules/finances/invoice/action-bar';
import editchargesControl from 'bz-pronto-core/modules/finances/invoice/edit-charges';
import editpaymentsControl from 'bz-pronto-core/modules/finances/invoice/edit-payments';
import changemenuitemControl from 'bz-pronto-core/modules/finances/invoice/options-menu/controls/change-menu-item';
import creditnotemenuitemControl from 'bz-pronto-core/modules/finances/invoice/options-menu/controls/credit-note-menu-item';
import discountmenuitemControl from 'bz-pronto-core/modules/finances/invoice/options-menu/controls/discount-menu-item';
import transfermenuitemControl from 'bz-pronto-core/modules/finances/invoice/options-menu/controls/transfer-menu-item';
import writeoffmenuitemControl from 'bz-pronto-core/modules/finances/invoice/options-menu/controls/write-off-menu-item';
import chargeextrasControl from 'bz-pronto-core/modules/finances/quickbill/charge-extras';
import paycontrolControl from 'bz-pronto-core/modules/finances/quickbill/pay-control';
import React from 'react';

export default {
  '0470ef85-bf41-4065-8a85-0ff3c78c4d59': {
    control: paycontrolControl,
    description: 'Pronto quickbill pay control'
  },
  '897368d1-5266-49ab-a51d-8059a8e1f419': {
    control: chargeextrasControl,
    description: 'Pronto quickbill charge extras'
  },
  '8e3f019c-92bd-4666-8140-f83f499a6839': {
    control: actionbarControl,
    description: 'Pronto invoice action bar for tm3'
  },
  '875cbd66-1f32-488f-9c06-84d9b3107bf5': {
    control: editpaymentsControl,
    description: 'Pronto invoice payments for tm3'
  },
  '4934f336-08ed-4c87-bdfe-84a2b366d7a2': {
    control: editchargesControl,
    description: 'Pronto invoice charges for tm3'
  },
  '74526953-ebfb-4169-944a-6fb2059bf693': {
    control: acknowledgedialogControl,
    description: 'Pronto invoice acknowledge rejection dialog for tm3'
  },
  'f172d3fa-9594-4ef8-8144-3fe36aa9beeb': {
    control: transfermenuitemControl,
    description: 'Pronto invoice options menu transfer menu item for tm3'
  },
  '50dcffd2-93cc-4ffb-88a6-ea7a4fd46681': {
    control: changemenuitemControl,
    description: 'Pronto invoice options menu change menu item for tm3'
  },
  '22859ee8-e949-4af9-b34b-e4adbca369a7': {
    control: writeoffmenuitemControl,
    description: 'Pronto invoice options menu write off menu item for tm3'
  },
  'a4631c70-8bd4-401e-b755-a49939f76b72': {
    control: creditnotemenuitemControl,
    description: 'Pronto invoice options menu credit note menu item for tm3'
  },
  '9e1908c2-309d-4015-95cb-0d3d05f1e367': {
    control: discountmenuitemControl,
    description: 'Pronto invoice options menu discount menu item for tm3'
  },
  '64a17438-16e9-4db8-9792-b221893797bc': {
    control: casefooterControl,
    description: 'Pronto integration case footer'
  },
  'ac9b7e52-ba39-4099-808d-f74caddc80d8': {
    control: moremenuitemControl,
    description: 'Pronto integration report menu items for more menu'
  },
  '10f34fa9-b4b0-4f14-a157-f4776c6a8410': {
    control: caseattachmentsControl,
    description: 'Pronto integration attachments section'
  },
  'c33b1d76-7160-4601-8cef-ae9527fa4188': {
    control: casereportControl,
    description: 'Pronto integration case report'
  },
  '33fe759f-cde7-476e-b1fd-71e38744e704': {
    control: reporteditorControl,
    description: 'Pronto integration case report editor'
  }
};
